// extracted by mini-css-extract-plugin
module.exports = {"btn":"Color_btn__13i4Q","wrapper":"Color_wrapper__3sXbv","input":"Color_input__p2E4v","sticky":"Color_sticky__1FDkG"};